<template>
  <div v-if="quote && Object.keys(quote).length > 0">
    <!-- MONTHLY -->
    <div
      v-if="monthly"
      @click="$emit('open-more-info')"
    >
      <div v-if="qd.calcMonthly > 0 && !isEversureBroker">
        <dl class="caption">
          <div class="d-flex info--text justify-space-between">
            <dt
              class="mr-3"
              :class="size === 'large' ? 'fs-16': undefined"
            >
              {{ qd.calcVariedAmount ? 'Deposit' : '1x' }}
            </dt>
            <dd
              class="font-weight-medium"
              :class="size === 'large' ? 'fs-16': undefined"
            >
              &pound;{{ qd.calcDeposit.toFixed(2) }}
            </dd>
          </div>

          <div
            v-if="qd.calcVariedAmount"
            class="d-flex justify-space-between"
          >
            <dt
              class="mr-3"
              :class="size === 'large' ? 'fs-16': undefined"
            >
              1x
            </dt>
            <dd
              class="font-weight-medium"
              :class="size === 'large' ? 'fs-16': undefined"
            >
              &pound;{{ qd.calcVariedAmount.toFixed(2) }}
            </dd>
          </div>
          <div
            class="d-flex justify-space-between align-center"
            :class="size === 'large' ? 'mt-1 mb-1': undefined"
          >
            <dt
              class="mr-3"
              :class="{
                'fs-16': size === 'large',
                'mt-2': qd.calcMonthly < smallest4DigitNumber,
              }"
            >
              <strong>{{ qd.numberOfInstallments }}x</strong>
            </dt>
            <dd
              class="font-weight-bold"
              :class="monthlyPriceClassName"
            >
              &pound;{{ qd.calcMonthly.toFixed(2) }}
            </dd>
          </div>
          <div class="d-flex justify-space-between">
            <dt
              class="mr-3 font-weight-bold"
              :class="size === 'large' ? 'fs-12': 'fs-10'"
            >
              Total
            </dt>
            <dd
              class="font-weight-bold"
              :class="size === 'large' ? 'fs-12': 'fs-10'"
            >
              &pound;{{ qd.calcMonthlyTotal.toFixed(2) }}
              <span v-if="showOptionalExtraLabel">*</span>
            </dd>
          </div>
          <results-price-cashback
            v-if="cashback"
            :cashback="cashback"
            :cashback-unit="qd.cashbackUnit"
          />
        </dl>

        <a
          v-if="showOptionalExtraLabel"
          href="#"
          class="d-block fs-10 font-weight-medium"
          :class="size === 'large' ? 'mt-3': undefined"
          @click.prevent="showPriceDescription"
        >
          Est. price with optional extras
        </a>
      </div>
      <div v-else>
        <div class="caption text-center">
          <div class="info--text font-weight-medium">
            Instalments
          </div>
          <div class="font-weight-bold">
            Check with provider
          </div>
        </div>
        <results-price-cashback
          v-if="cashback"
          :cashback="cashback"
          :cashback-unit="qd.cashbackUnit"
        />
      </div>
    </div>
    <!-- ANNUAL -->
    <div
      v-else
      class="text-center"
      @click="$emit('open-more-info')"
    >
      <p
        class="font-weight-bold mb-0"
        :class="{
          'headline': !size,
          'display-2': size === 'large',
          'title': size === 'small',
        }"
        v-html="calcAnnual"
      />
      <p
        v-if="qd.calcAnnual !== parseFloat(qd.annualPremium)"
        class="info--text mb-0"
        :class="{
          'fs-11': !size || size === 'large',
          'fs-10': size === 'small',
        }"
      >
        <em>
          &pound;{{ qd.annualPremium.toFixed(2) }} excluding optional extras
        </em>
      </p>
      <p
        v-else-if="productName !== 'travel'"
        class="caption mb-0"
      >
        per year
      </p>
      <results-price-cashback
        v-if="cashback"
        :cashback="cashback"
        :cashback-unit="qd.cashbackUnit"
      />
    </div>
  </div>
</template>

<script>
import ResultsPriceCashback from './ResultsPriceCashback.vue';

// For large price (more than 1000) we need to change font-size so it fits in the table cell
const smallest4DigitNumber = 1000;

export default {
  name: 'results-price',
  inject: [
    'productName',
    'helpers',
  ],
  components: {
    ResultsPriceCashback,
  },
  props: {
    quote: {
      required: false,
      type: Object,
      default: () => {},
    },
    monthly: {
      required: false,
      type: Boolean,
      default: false,
    },
    size: {
      required: false,
      type: String,
      default: '',
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    cashback: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      smallest4DigitNumber,
    };
  },
  computed: {
    qd () {
      return this.quote.details[0];
    },
    calcAnnual () {
      const classes = [];
      if (!this.size || this.size === 'small') classes.push('subtitle-2');
      if (this.size === 'large') classes.push('headline');
      return this.helpers.getPriceTemplate(this.qd.calcAnnual, classes);
    },
    showOptionalExtraLabel () {
      return this.selectedOptionalExtras.some(extra => this.qd.optionalExtra[extra]?.included === 'extra');
    },
    monthlyPriceClassName () {
      if (this.qd.calcMonthly >= this.smallest4DigitNumber) {
        return 'fs-16';
      }

      if (this.size === 'large') {
        return 'headline';
      }

      return 'title';
    },
    isEversureBroker () {
      // Requirement from business for specific insurer
      return this.qd.brokerFullName === 'Eversure' && this.qd.deposit === 0;
    },
  },
  methods: {
    showPriceDescription () {
      this.$emit('open-drawer-details', ['details-description', 'estimatedPrice']);
    },
  },
};
</script>
